// extracted by mini-css-extract-plugin
export var animation = "DevOps-module--animation--7b391";
export var cloudDifferences = "DevOps-module--cloud-differences--c017e";
export var typographies = "DevOps-module--typographies--4ff33";